module.exports = __webpack_public_path__ + "img/theme15.243f40a4.png";